import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useCompany } from '../context/CompanyContext';

/**
 * Subscribes in real-time to the total count of unread inbound messages
 * across all non-resolved conversations for the current company.
 *
 * Firestore query: conversations where unreadCount > 0
 * Client filter:   exclude status === 'resolved'
 *
 * @returns {number} total unread count (0 when nothing pending)
 */
export function useUnreadCount() {
  const { companyId } = useCompany();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!companyId || !db) return;

    const q = query(
      collection(db, 'companies', companyId, 'conversations'),
      where('unreadCount', '>', 0)
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        let total = 0;
        snap.docs.forEach((d) => {
          const data = d.data();
          // Resolved conversations are archived — don't count toward the badge
          if (data.status !== 'resolved') {
            total += data.unreadCount || 0;
          }
        });
        setUnreadCount(total);
      },
      (err) => {
        console.warn('[useUnreadCount] subscription error:', err);
      }
    );

    return () => unsub();
  }, [companyId]);

  return unreadCount;
}
